var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPreferences = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_Preferences",
    d: "M15.976,12.776c-.4,0-.7.1-1,.1l-2.888-2.9,2.39-2.4,3.087-1.1,2.29-3.7a.63.63,0,0,0,0-.6l-1.2-1.2a.612.612,0,0,0-.7-.1l-3.784,2.2-1.2,3.2L10.6,8.68l-2.689-2.9c0-.3.1-.6.1-1A4.048,4.048,0,0,0,3.03.889l1.494,1.5a1.935,1.935,0,0,1,0,2.8,1.921,1.921,0,0,1-2.788,0L.142,3.786A3.915,3.915,0,0,0,5.022,8.58l2.888,2.9-1.2,1.2a1.892,1.892,0,0,0-1.892.5l-4.083,4.1a2.037,2.037,0,0,0-.2,2.8,1.958,1.958,0,0,0,2.888.1l4.183-4.2a1.964,1.964,0,0,0,.5-1.9l1.2-1.2,2.888,2.9a3.408,3.408,0,0,0-.1,1,4.048,4.048,0,0,0,4.979,3.9l-1.494-1.5a1.975,1.975,0,1,1,2.788-2.8l1.494,1.5A4.051,4.051,0,0,0,15.976,12.776Z",
    transform: "translate(0 -.778)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPreferences);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_preferences.a6557a48941dda04412ed9b572ef7920.svg";